import { inject, Injectable } from "@angular/core";
import { getAuth } from "@angular/fire/auth";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { IRole } from "@nova/common-interfaces";
import { map } from "rxjs";
import { AuthService } from "../services/auth/auth.service";
import { PathService } from "../services/auth/path.service";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
  // #region Constructors (1)

  constructor(
    private authService: AuthService,
    private router: Router,
    private pathService: PathService
  ) {}

  // #endregion Constructors (1)

  // #region Public Methods (2)

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {

    if (state.url.includes('reset-password-confirm')) { // Replace with your confirmation route
      return true; // Allow access without authentication
    }
    
    const requiredRole = route.data["roles"];
    this.pathService.setPath(state.url, true);

    const user = getAuth().currentUser;

      if (user) { 
        await this.checkClaims(requiredRole);
        return true;
      } else {
        return this.router.createUrlTree(["/login"]);
      }
  }

  public async checkClaims(requireRole: any)  {

    this.authService.claims.claims$.pipe(
      map((roles) => {
        if (
          requireRole.some((el: IRole) =>
            roles.filter((el: IRole) => el.role_name)
          )
        ) {
          return Promise.resolve(true);
        } else {
          return Promise.resolve(false);
        }
      })
    );
  }

  // #endregion Public Methods (2)
}

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const guard = inject(AuthGuard);
  return guard.canActivate(route, state);
};
